<template>
  <div class="home">
    <div v-if="loading">
      <v-progress-circular
        indeterminate
        color="yellow"
      />
    </div>

    <div
      v-else-if="!loading"
      style="text-align:center"
    >
      <div
        v-if="selected === 0"
        class="choice"
      >
        <div
          class="text"
          @click="selected = 1"
        >
          Vol. 1
        </div>
        <div
          class="text"
          @click="selected = 2"
        >
          Vol. 2
        </div>
      </div>
      <div v-else-if="selected === 1">
        <h2>
          GALERIE
        </h2>
        <div style="display:flex; justify-content:center; width:100%;">
          <img
            src="../../assets/plus.jpg"
            style=" padding:10px;"
            @click="addNewGalleryImage = true"
          >
        </div>
        <h3>
          Vol. 1
        </h3>

        <div style="width:100%; max-width:1200px; display:flex; flex-direction:column; align-items: start">
          <div>
            <h3>
              Vol. 1
            </h3>
          </div>

          <div style="display:flex; flex-direction:row">
            <div
              v-for="i in images"
              :key="i.id"
            >
              <img
                :src="i.image"
                style="padding:10px; cursor:pointer;"
                @click="show = true; img = i.image"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <show-image
      :show="show"
      :img="img"
      @close="show = false"
    />
    <add-new-gallery-image
      :add-new-gallery-image="addNewGalleryImage"
      :images="images"
      @pushImage="pushImage"
      @close="addNewGalleryImage = false"
    />
  </div>
</template>

<script>
import AddNewGalleryImage from '../dialogs/AddNewGalleryImage.vue'
import ShowImage from '@/components/dialogs/ShowImage.vue'
import db from '../../fb'
export default {
  name: 'HomeView',
  components: {
    ShowImage,
    AddNewGalleryImage
  },
  data () {
    return {
      selected: 0,
      img: '',
      show: false,
      image1: false,
      image2: false,
      image3: false,
      image4: false,
      registration: false,
      date: '',
      edit: [],
      images: [],
      loading: false,
      addNewGalleryImage: false
    }
  },
  created () {
    this.loading = true
    this.playMusic()
    db.collection('editText').get().then(res => {
      // eslint-disable-next-line array-callback-return
      res.docs.map(doc => {
        const pes = doc.data()
        pes.id = doc.id
        this.edit.push(pes)
        console.log(pes)
      }

      )
      const d = this.edit.filter(edit => edit.id === 'date')
      this.date = d[0].date
    })
    db.collection('editGallery').get().then(res => {
      // eslint-disable-next-line array-callback-return
      res.docs.map(doc => {
        this.images.push(doc.data())
        console.log(doc.data())
      })
      this.loading = false
    })
  },
  methods: {
    playMusic () {
      setTimeout(() => {
        console.log('pes')
      }, 1000)
    },
    pushImage (obj) {
      this.images.push(obj)
    },
    select (url) {
      window.open(url)
    }
  }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Six+Caps&display=swap');
body, html{
   background-color: black;

}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s, filter 0.5s;
}
.choice{
  margin-top:30px;
}
.choice .text{

font-size: 4vw;
cursor: pointer;
transition: font-size 0.3s;
}
.choice .text:hover{
font-size: 5vw;
cursor: pointer;
}
.v-enter-from,
.v-leave-to {
  opacity: 0;
  filter: blur(40px);
}
.home{
  padding-inline: 10px;
  color: #f9d71c;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: black;
  font-family: 'Six Caps', sans-serif;
}
.home h2{
font-size: 8vw;
text-decoration: underline #fd48fe;
}
h3{
    font-size: 2vw;
    text-decoration: underline #fd48fe;
}
@media only screen and (min-width : 320px) {
       img{
  width:100%;
   max-height: 200px;
  /* max-width:100px; */
}
    }

    /* Extra Small Devices, Phones */
    @media only screen and (min-width : 480px) {
img{
  width:100%;
  max-height: 250px;
  /* max-width:120px; */
}
    }

    /* Small Devices, Tablets */
    @media only screen and (min-width : 768px) {
img{
  width:100%;
  max-height: 300px;
  /* max-width:170px; */
}
    }
</style>
